import React from 'react';
import { Field, CccisdInput, CccisdToggle, CccisdWysiwyg } from 'cccisd-formik';
import { widgetBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    show: true,
    title: 'Recommendations',
    content: '<div />',
};

const Component = props => {
    return (
        <div>
            <Field name="show" component={CccisdToggle} label="Show Recommendations?" />
            <Field name="title" component={CccisdInput} label="Title" />
            <Field name="content" component={CccisdWysiwyg} label="Content" />
        </div>
    );
};

export default widgetBuilder({ initialValues })(Component);
